import { render } from "./ActoresMovimientos.vue?vue&type=template&id=290ccc42"
import script from "./ActoresMovimientos.vue?vue&type=script&lang=js"
export * from "./ActoresMovimientos.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__